import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";
import * as _ from "lodash-joins";

// import Pagination from "../../commons/components/Paginations.jsx";
import AS from "../Login/Service/Authentication.js";
// import CS from "../../commons/services/Common.js";
// import VS from "../../commons/services/Validation.js"
import Modal from "../../commons/components/Modal.jsx";

import PaginationButtons from "../../commons/components/pagination/PaginationButtons.jsx";
import { ROUTES } from "../../commons/constants/routes/routes.js";
import { getUpdatedSearchParam } from "../../commons/services/Router.js";
import { withTranslation } from "react-i18next";
import { getCurrentLang } from "../../commons/services/Translation.js";
import MapGoogle from "./MapGoogle.jsx";

const PROJECT_STATUS = {
  "1": { label: "설치전",   color: "#888e98" },
  "2": { label: "설치중",   color: "#f59e0b" },
  "3": { label: "설치완료", color: "#1ab245" },
  "4": { label: "보완요청", color: "#ff5353" },
};

// UI의 searchType 값 -> 서버 API의 searchType 값
const SEARCH_TYPE_MAP = {
  addr: "address",
  project: "subject",
  customer: "customer_name",
};

// 법정동코드(행정표준코드) 상 시도 코드 - Site 번호 생성에 쓰이는 법정동코드(카카오 주소검색 API b_code)의 앞 2자리와 동일한 체계
const SIDO_LIST = [
  { code: "11", name: "서울특별시" },
  { code: "26", name: "부산광역시" },
  { code: "27", name: "대구광역시" },
  { code: "28", name: "인천광역시" },
  { code: "29", name: "광주광역시" },
  { code: "30", name: "대전광역시" },
  { code: "31", name: "울산광역시" },
  { code: "36", name: "세종특별자치시" },
  { code: "41", name: "경기도" },
  { code: "42", name: "강원특별자치도" },
  { code: "43", name: "충청북도" },
  { code: "44", name: "충청남도" },
  { code: "45", name: "전북특별자치도" },
  { code: "46", name: "전라남도" },
  { code: "47", name: "경상북도" },
  { code: "48", name: "경상남도" },
  { code: "50", name: "제주특별자치도" },
];

const STEP1_FIELDS = [
  { key: "imgHomeAddress",      label: "집 주소 사진" },
  { key: "imgIntegratedBoxOut", label: "현장 전경 사진" },
  { key: "imgHpBoxOut",         label: "히트펌프 명판 사진" },
  { key: "imgLocalBoxOut",      label: "태양광 설치 사진" },
  { key: "imgNexaOut",          label: "모듈 명판 사진" },
  { key: "imgHeatpumpOut",      label: "인버터 설치 사진" },
  { key: "imgHeatMeter",        label: "적산열량계 설치 사진" },
  { key: "imgExtra01",          label: "기타" },
];
const STEP2_FIELDS = [
  { key: "imgIntegratedBoxIn", label: "통합함 내부 결선 사진" },
  { key: "imgHpBoxIn",         label: "HP함 내부 결선 사진" },
  { key: "imgLocalBoxIn",      label: "적산열량계 결선 사진" },
  { key: "imgHeatpumpIn",      label: "히트펌프 결선 사진" },
  { key: "imgNexaIn",          label: "NEXA 내부 사진" },
  { key: "imgExtra02",         label: "RTU S/N 사진" },
  { key: "imgExtra03",         label: "RTU S/N 사진" },
  { key: "imgExtra04",         label: "기타" },
];
const EXTRA_FIELDS = [
  { key: "imgExtra05", label: "추가사진 5" },
];
const CHECKLIST_OPTIONS = ["적합", "미흡", "해당없음"];
const CHECKLIST_ITEMS = [
  { key: "checklist1",  question: "NEXA함이 지정된 위치에 설치되었는가?" },
  { key: "checklist2",  question: "NEXA함 외관 손상은 없는가?" },
  { key: "checklist3",  question: "히트펌프와 정상적으로 연결되었는가?" },
  { key: "checklist4",  question: "전력량계 또는 적산열량계와 정상적으로 연결되었는가?" },
  { key: "checklist5",  question: "통신 배선이 정상적으로 연결되었는가?" },
  { key: "checklist6",  question: "전원 공급 상태가 정상인가?" },
  { key: "checklist7",  question: "배선 정리가 적절하게 되어 있는가?" },
  { key: "checklist8",  question: "현장 사진이 모두 등록되었는가?" },
  { key: "checklist9",  question: "설치 후 주변 정리가 완료되었는가?" },
  { key: "checklist10", question: "특이사항이 있는 경우 메모를 작성했는가?" },
];

const MIME_EXT_MAP = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/gif": "gif",
  "image/webp": "webp",
  "image/bmp": "bmp",
};

function PhotoImage({ fileId, onClickImg }) {
  const [thumbSrc, setThumbSrc] = React.useState(null);
  const [downloading, setDownloading] = React.useState(false);

  React.useEffect(() => {
    if (!fileId) return;
    let objectUrl;
    axios.get(`/api/file/thumbnail/${fileId}`, { responseType: "blob" })
      .then((res) => {
        objectUrl = URL.createObjectURL(res.data);
        setThumbSrc(objectUrl);
      })
      .catch(() => {});
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [fileId]);

  const handleDownload = async (e) => {
    e.stopPropagation();
    if (downloading) return;
    setDownloading(true);
    try {
      const res = await axios.get(`/api/file/${fileId}`, { responseType: "blob" });
      const ext = MIME_EXT_MAP[res.data.type] || "jpg";
      const objectUrl = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = `${fileId}.${ext}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (e) {
      console.log(e);
    } finally {
      setDownloading(false);
    }
  };

  if (!fileId) return <div className="photo-placeholder">-</div>;
  if (!thumbSrc) return <div className="photo-placeholder loading">...</div>;
  return (
    <>
      <img
        src={thumbSrc}
        alt=""
        className="photo-thumb"
        onClick={() => onClickImg(fileId)}
      />
      <button
        type="button"
        className="photo-download-btn"
        onClick={handleDownload}
        disabled={downloading}
      >
        {downloading ? "다운로드중..." : "다운로드"}
      </button>
    </>
  );
}

/**
 * 2024.08.19
 */
class ProjectMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chkbox: false,
      items: [],
      points: [],
      totalCount: 0,
      perPageSize: 10,
      currentPage: null,
      orderType: "DESC",
      searchType: "addr",
      keyword: "",
      searchCenter: null,
      isMonitoringShow: false,
      approvedProjectList: null,
      totalPageCount: 0,
      projectMemberMap: {},
      stats: {},
      statusFilter: null,
      sidoFilter: "",
      siteManagers: [],
      siteManagerFilter: "",
      showPhotoPopup: false,
      photoData: null,
      checklistData: {},
      lightboxSrc: null,
    };
    this.getItems = this.getItems.bind(this);
    this.getMapPoints = this.getMapPoints.bind(this);
    this.handleChangeChk = this.handleChangeChk.bind(this);
    this.handleSortChange = this.handleSortChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.updatePageParam = this.updatePageParam.bind(this);
  }

  async componentDidMount() {
    const page = this.initPaginationSearchParam();
    await Promise.all([this.getItems(Number(page)), this.getSiteManagers()]);
    this.getStats();
  }

  componentDidUpdate(prevProps, prevState) {
    const isSamePageLocation = prevProps.location.search === this.props.location.search;
    if (!isSamePageLocation) {
      const page = this.getPageSearchParam();
      const pageNum = page ? Number(page) : 1;
      if (pageNum !== prevState.currentPage) {
        this.setState({ currentPage: pageNum }, () => {
          if (!this.state.chkbox) this.getItems();
        });
      }
    }
  }

  // 목록/지도 중 현재 보기 모드에 맞는 데이터를 다시 조회한다.
  refreshData = () => {
    if (this.state.chkbox) {
      this.getMapPoints();
    } else {
      this.getItems();
    }
  };

  // 검색/필터 조건을 서버 쿼리 파라미터로 변환한다.
  buildBaseParams() {
    const { searchType, keyword, sidoFilter, siteManagerFilter, statusFilter } = this.state;
    const params = {};
    if (sidoFilter) params.sidoCode = sidoFilter;
    if (siteManagerFilter) params.siteManagerId = siteManagerFilter;
    if (statusFilter !== null) params.status = statusFilter;
    if (searchType && keyword) {
      params.searchType = SEARCH_TYPE_MAP[searchType] || searchType;
      params.searchText = keyword;
    }
    return params;
  }

  getPageSearchParam() {
    const params = new URLSearchParams(this.props.location.search);
    const page = params.get("page");
    return page;
  }

  initPaginationSearchParam(initPage) {
    const page = initPage ? initPage : (this.getPageSearchParam() || 1);

    this.setState({ currentPage: Number(page) });
    return page;
  }

  updatePageParam(page) {
    const updatedParams = getUpdatedSearchParam({ page }, this.props.location);
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: updatedParams
    });
  }

  // 목록(테이블) 모드: page/pageSize 단위로 잘라서 조회
  async getItems(pageOverride) {
    const constructorId = AS.getLoggedInId();
    const { perPageSize } = this.state;
    const currentPage = pageOverride || this.state.currentPage || 1;

    try {
      const params = {
        ...this.buildBaseParams(),
        page: currentPage,
        pageSize: perPageSize,
      };
      const res = await axios.get(`/cst/api/project/${constructorId}`, { params });
      const projects = res.data.data;
      const recordsTotal = res.data.recordsTotal;
      const projectIds = projects.map((project) => project.id);

      this.setState(
        {
          items: projects,
          totalCount: recordsTotal,
          totalPageCount: Math.max(1, Math.ceil(recordsTotal / perPageSize)),
        },
        async () => {
          await Promise.all([
            this.checkUserApproves(projectIds),
            this.fetchMemberLinks(projects),
          ]);
        }
      );
    } catch (e) {
      console.log(e);
    }
  }

  // 지도 모드: 조건에 맞는 전체 핀을 한번에 조회
  // TODO: 백엔드에 좌표 전용 비페이징 API가 추가되면 큰 pageSize 우회 대신 그 API로 교체
  async getMapPoints() {
    const constructorId = AS.getLoggedInId();
    const { keyword } = this.state;

    try {
      const params = { ...this.buildBaseParams(), page: 1, pageSize: 100000 };
      const res = await axios.get(`/cst/api/project/${constructorId}`, { params });
      const projects = res.data.data;

      const points = _.chain(projects)
        .groupBy((v) => `${v.lngX},${v.latY}`)
        .map((groups, xy) => ({ xy, groups }))
        .value();

      const matchedItem = keyword
        ? projects.find((item) => item.address && item.address.includes(keyword))
        : null;

      this.setState({
        points,
        totalCount: res.data.recordsTotal,
        searchCenter: matchedItem ? { lng: matchedItem.lngX, lat: matchedItem.latY } : null,
      });
    } catch (e) {
      console.log(e);
    }
  }

  openPhotoPopup = async (projectId) => {
    try {
      const res = await axios.get("/api/site-manager/device-install-info", { params: { projectId } });
      const raw = res.data?.data ?? res.data;
      const photoData = Array.isArray(raw) ? raw[0] : raw;
      const checklistData = {};
      CHECKLIST_ITEMS.forEach(({ key }) => {
        checklistData[key] = photoData?.[key] || null;
      });
      this.setState({ showPhotoPopup: true, photoData, checklistData });
    } catch (e) {
      console.log(e);
    }
  }

  closePhotoPopup = () => {
    this.closeLightbox();
    this.setState({ showPhotoPopup: false, photoData: null, checklistData: {} });
  }

  openLightbox = async (fileId) => {
    if (!fileId) return;
    try {
      const res = await axios.get(`/api/file/${fileId}`, { responseType: "blob" });
      const objectUrl = URL.createObjectURL(res.data);
      this.setState({ lightboxSrc: objectUrl });
    } catch (e) {
      console.log(e);
    }
  }

  closeLightbox = () => {
    if (this.state.lightboxSrc) URL.revokeObjectURL(this.state.lightboxSrc);
    this.setState({ lightboxSrc: null });
  }


  async getSiteManagers() {
    try {
      const res = await axios.get("/api/account/account", { params: { userType: "USR_S" } });
      this.setState({ siteManagers: res.data.data || [] });
    } catch (e) {
      console.log(e);
    }
  }

  async getStats() {
    try {
      const res = await axios.get("/api/project/stats");
      this.setState({ stats: res.data });
    } catch (e) {
      console.log(e);
    }
  }

  handleStatusFilter(statusFilter) {
    this.setState({ statusFilter, currentPage: 1 }, () => {
      this.refreshData();
      this.updatePageParam(1);
    });
  }

  async fetchMemberLinks(projects) {
    const results = await Promise.all(
      projects.map(async (p) => {
        try {
          const res = await axios.get(`/cst/api/user-project/${p.id}`);
          return { id: p.id, hasMembers: (res.data || []).length > 0 };
        } catch {
          return { id: p.id, hasMembers: false };
        }
      })
    );
    const map = {};
    results.forEach(({ id, hasMembers }) => { map[id] = hasMembers; });
    this.setState({ projectMemberMap: map });
  }

  async checkUserApproves(projectIds) {
    try {
      const res = await axios.post(
        "/cst/api/constructor-plant/user-approve-check",
        projectIds
      );

      if (res.data.result) {
        const approvedProjects = res.data.result;
        if (approvedProjects.length > 0) {
          this.setState({ isMonitoringShow: true });
          this.setState({ approvedProjectList: approvedProjects });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  // 정렬(오래된순/최신순): 현재 서버는 id 내림차순 고정이라 아직 서버에 전달되지 않는다.
  // TODO: 백엔드에 정렬 파라미터가 추가되면 buildBaseParams()에 반영할 것
  handleSortChange(e) {
    this.setState({ orderType: e.target.value, currentPage: 1 }, () => {
      this.refreshData();
      this.updatePageParam(1);
    });
  }

  handleSearchChange(e) {
    this.setState({ [e.target.id]: e.target.value });
  }

  handleSearch(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ currentPage: 1 }, () => {
      this.refreshData();
      if (e) {
        this.updatePageParam(1);
      }
    });
  }

  handleChangeChk(e) {
    const chkbox = e.target.checked;
    this.setState(
      {
        chkbox: chkbox,
        orderType: chkbox ? "" : "DESC",
        searchType: chkbox ? "addr" : "",
        keyword: "",
        currentPage: 1,
        searchCenter: chkbox ? this.state.searchCenter : null,
      },
      () => {
        this.refreshData();
        this.updatePageParam(1);
      }
    );
  }

  render() {
    const {
      chkbox,
      orderType,
      searchType,
      keyword,
      items,
      searchCenter,
      isMonitoringShow,
      approvedProjectList,
      projectMemberMap,
      stats,
      statusFilter,
      sidoFilter,
      siteManagers,
      siteManagerFilter,
      showPhotoPopup,
      photoData,
      checklistData,
      lightboxSrc,
    } = this.state;

    const { t, i18n } = this.props;

    const lang = getCurrentLang(i18n);
    return (
      <PlantListWrap>
        <div className="page-tit gray">
          <div className="container f-stack">
            <h2 className="tit">{t('key31')}</h2>
            <div style={{ display: "flex", gap: "10px" }}>
              <Link to={ROUTES.SITE_MANAGER.MAIN} className="btn secondary">
                현장담당자
              </Link>
              <Link to={ROUTES.PROJECT.CREATE} className="btn primary">
                {t('key32')}
              </Link>
            </div>
          </div>
        </div>
        <StatsSection className="container">
          <StatCard
            active={statusFilter === null}
            color="#0db14b"
            onClick={() => this.handleStatusFilter(null)}
          >
            <span className="stat-count">{stats.total ?? "-"}</span>
            <span className="stat-label">전체 현장</span>
          </StatCard>
          <StatCard
            active={statusFilter === "1"}
            color="#888e98"
            onClick={() => this.handleStatusFilter("1")}
          >
            <span className="stat-count">{stats.beforeInstall ?? "-"}</span>
            <span className="stat-label">설치전 현장</span>
          </StatCard>
          <StatCard
            active={statusFilter === "2"}
            color="#f59e0b"
            onClick={() => this.handleStatusFilter("2")}
          >
            <span className="stat-count">{stats.installing ?? "-"}</span>
            <span className="stat-label">설치중 현장</span>
          </StatCard>
          <StatCard
            active={statusFilter === "3"}
            color="#1ab245"
            onClick={() => this.handleStatusFilter("3")}
          >
            <span className="stat-count">{stats.installComplete ?? "-"}</span>
            <span className="stat-label">설치완료 현장</span>
          </StatCard>
          <StatCard
            active={statusFilter === "4"}
            color="#ff5353"
            onClick={() => this.handleStatusFilter("4")}
          >
            <span className="stat-count">{stats.supplementRequested ?? "-"}</span>
            <span className="stat-label">보완요청 현장</span>
          </StatCard>
        </StatsSection>
        <div className="container">
          <div className="top-search">
            <p className="all">
              {t('key33')}<span> {t('key34')} {this.state.totalCount}{t('key35')}</span>
            </p>
            <div className="search">
              <form onSubmit={this.handleSearch}>
                <select
                  title="시도 선택"
                  value={sidoFilter}
                  onChange={(e) => {
                    const val = e.target.value;
                    this.setState({ sidoFilter: val, currentPage: 1 }, () => {
                      this.refreshData();
                      this.updatePageParam(1);
                    });
                  }}
                >
                  <option value="">시도 전체</option>
                  {SIDO_LIST.map((s) => (
                    <option key={s.code} value={s.code}>{s.name}</option>
                  ))}
                </select>
                <select
                  title="현장관리자 선택"
                  value={siteManagerFilter}
                  onChange={(e) => {
                    const val = e.target.value;
                    this.setState({ siteManagerFilter: val, currentPage: 1 }, () => {
                      this.refreshData();
                      this.updatePageParam(1);
                    });
                  }}
                >
                  <option value="">현장관리자 전체</option>
                  {siteManagers.map((m) => (
                    <option key={m.id} value={m.id}>{m.userName}</option>
                  ))}
                </select>
                {!chkbox && (
                  <select
                    id="orderType"
                    title="정렬선택"
                    value={orderType}
                    onChange={this.handleSortChange}
                  >
                    <option value="DESC">{t('key36')}</option>
                    <option value="ASC">{t('key37')}</option>
                  </select>
                )}
                <select
                  id="searchType"
                  title="종류선택"
                  value={searchType}
                  onChange={this.handleSearchChange}
                  disabled={chkbox}
                >
                  <option value="addr">{t('key38')}</option>
                  {!chkbox && <option value="project">{t('key39')}</option>}
                  {!chkbox && <option value="customer">고객명</option>}
                </select>
                <div className="input-search">
                  <input
                    type="text"
                    id="keyword"
                    placeholder={t('key40')}
                    value={keyword}
                    onChange={this.handleSearchChange}
                  />
                  <button type="submit" className="material-icons">
                    search
                  </button>
                </div>
              </form>
              <div className="map-box">
                <label htmlFor="idCheck">
                  <input
                    type="checkbox"
                    id="idCheck"
                    checked={chkbox}
                    onChange={this.handleChangeChk}
                  />
                  {t('key41')}
                </label>
              </div>
            </div>
          </div>

          {chkbox ? (
            <MapGoogle points={this.state.points} searchCenter={searchCenter} />
          ) : (
            <div className="table-wrapper">
              <table className="h-table">
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "11%" }} />
                  <col style={{ width: "18%" }} />
                  <col style={{ width: "9%" }} />
                  <col style={{ width: "11%" }} />
                  <col style={{ width: "9%" }} />
                  <col style={{ width: lang === "vi" ? "22%" : "17%" }} />
                </colgroup>
                <thead>
                  <tr>
                    <th>{t('key42')}</th>
                    <th>{t('key43')}</th>
                    <th>고객명</th>
                    <th>{t('key44')}</th>
                    <th>{t('key45')}</th>
                    <th>현장담당자/회원</th>
                    <th>상태</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {items.length > 0 ? (
                    items.map((row, index) => (
                      <tr key={row.id}>
                        <td>
                          {this.state.totalCount -
                            ((this.state.currentPage - 1) * this.state.perPageSize + index)}
                        </td>
                        <td title={row.name} className="project-name">{row.name}</td>
                        <td>{row.customerName}</td>
                        <td className="left">{row.address}</td>
                        <td>
                          {row.createDt &&
                            new Date(row.createDt).toISOString().split("T")[0]}
                        </td>
                        <td>
                          <LinkBadge linked={!!row.siteManagerId}>{row.siteManagerId ? "O" : "X"}</LinkBadge>
                          <span style={{ color: "#aaa" }}> / </span>
                          <LinkBadge linked={!!projectMemberMap[row.id]}>{projectMemberMap[row.id] ? "O" : "X"}</LinkBadge>
                        </td>
                        <td>
                          {row.status ? (
                            <StatusBtn
                              color={PROJECT_STATUS[String(row.status)]?.color}
                              onClick={() => this.openPhotoPopup(row.id)}
                            >
                              {PROJECT_STATUS[String(row.status)]?.label || row.status}
                            </StatusBtn>
                          ) : "-"}
                        </td>
                        <td>
                          <Link
                            to={{
                              // pathname: `/ems/main/${row.id}`,
                              pathname: ROUTES.EMS_NEW(row.id),
                              state: {
                                projectTitle: row.name,
                                projectId: row.id,
                                project: row
                              }
                            }}
                            className="link-btn ems-link"
                          >
                          EMS
                          </Link>
                          <Link
                            to={{ 
                              pathname: ROUTES.PLANT_LIST(row.id).MAIN,
                              state: {
                                projectTitle: row.name,
                              }
                            }}
                            style={{ width: lang === "vi" ? "100px" : "" }}
                            className="link-btn plant-link"
                          >
                            {t('key47')}
                          </Link>
                          <Link
                            className="edit-link link-btn"
                            style={{ width: lang === "vi" ? "100px" : "" }}
                            to={ROUTES.PROJECT.EDIT(row.id)}
                          >
                            {t('key48')}
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8">{t('key509')}</td>
                    </tr>
                  )}
                </tbody>
              </table>
              {
                this.state.totalCount > this.state.perPageSize && (
                  <PaginationButtons
                    totalPageCount={this.state.totalPageCount}
                    currentPage={this.state.currentPage}
                    onChangePage={this.updatePageParam}
                  />
                )
              }
            </div>
          )}
        </div>
        {showPhotoPopup && (
          <PhotoPopupOverlay onClick={this.closePhotoPopup}>
            <PhotoPopupBox onClick={(e) => e.stopPropagation()}>
              <PhotoPopupHeader>
                <h3>설치 사진 조회</h3>
                <button type="button" onClick={this.closePhotoPopup}>✕</button>
              </PhotoPopupHeader>
              <PhotoPopupBody>
                <PhotoSection>
                  <PhotoSectionTitle>Step 1 — 설치 전 외부 사진</PhotoSectionTitle>
                  <PhotoGrid>
                    {STEP1_FIELDS.map(({ key, label }) => (
                      <PhotoCell key={key}>
                        <span className="cell-label">{label}</span>
                        <PhotoImage
                          fileId={photoData?.[key]}
                          onClickImg={this.openLightbox}
                        />
                      </PhotoCell>
                    ))}
                  </PhotoGrid>
                </PhotoSection>
                <PhotoSection>
                  <PhotoSectionTitle>Step 2 — 설치 완료 후 내부 사진</PhotoSectionTitle>
                  <PhotoGrid>
                    {STEP2_FIELDS.map(({ key, label }) => (
                      <PhotoCell key={key}>
                        <span className="cell-label">{label}</span>
                        <PhotoImage
                          fileId={photoData?.[key]}
                          onClickImg={this.openLightbox}
                        />
                      </PhotoCell>
                    ))}
                  </PhotoGrid>
                </PhotoSection>
                {EXTRA_FIELDS.some(({ key }) => photoData?.[key]) && (
                  <PhotoSection>
                    <PhotoSectionTitle>추가 사진</PhotoSectionTitle>
                    <PhotoGrid>
                      {EXTRA_FIELDS.map(({ key, label }) => (
                        <PhotoCell key={key}>
                          <span className="cell-label">{label}</span>
                          <PhotoImage
                            fileId={photoData?.[key]}
                            onClickImg={this.openLightbox}
                          />
                        </PhotoCell>
                      ))}
                    </PhotoGrid>
                  </PhotoSection>
                )}
                <ChecklistSection>
                  <PhotoSectionTitle>Step 3 — 설치 후 체크리스트</PhotoSectionTitle>
                  <ChecklistList>
                    {CHECKLIST_ITEMS.map(({ key, question }, idx) => (
                      <ChecklistRow key={key}>
                        <ChecklistQuestion>
                          <span className="num">{idx + 1}.</span>
                          {question}
                        </ChecklistQuestion>
                        <ChecklistOptions>
                          {CHECKLIST_OPTIONS.map((opt) => (
                            <ChecklistOption
                              key={opt}
                              value={opt}
                              active={checklistData[key] === opt}
                            >
                              {opt}
                            </ChecklistOption>
                          ))}
                        </ChecklistOptions>
                      </ChecklistRow>
                    ))}
                  </ChecklistList>
                  <ChecklistFooter>
                    <button
                      type="button"
                      onClick={() => {
                        this.closePhotoPopup();
                        this.props.history.push(ROUTES.PROJECT.EDIT(photoData?.projectId));
                      }}
                    >
                      보완요청
                    </button>
                  </ChecklistFooter>
                </ChecklistSection>
              </PhotoPopupBody>
            </PhotoPopupBox>
          </PhotoPopupOverlay>
        )}

        {lightboxSrc && (
          <LightboxOverlay onClick={this.closeLightbox}>
            <LightboxImg src={lightboxSrc} alt="" onClick={(e) => e.stopPropagation()} />
            <LightboxClose onClick={this.closeLightbox}>✕</LightboxClose>
          </LightboxOverlay>
        )}

        {isMonitoringShow && (
          <Modal
            isMulti={true}
            icon={false}
            title={"Confirm"}
            btnGroup={true}
            approvedProjectList={approvedProjectList}
            filteredItems={items}
          />
        )}
      </PlantListWrap>
    );
  }
}

const PlantListWrap = styled.div`
  .page-tit .btn {
    width: 168px;
    border-radius: 8px;
  }
  .project-name {
    padding: 0 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .top-search .all {
    font-size: 15px;
    font-weight: bold;
    color: #191919;
    span {
      font-weight: normal;
      color: #888e98;
      display: inline-block;
      margin-left: 10px;
    }
  }
  .map-box {
    display: inline-block;
    input {
      display: inline-block;
      margin: 0 5px 0 12px;
    }
    label {
      display: inline-block;
    }
  }
  .search {
    display: flex;
    align-items: center;
  }
  .search form {
    display: flex;
    align-items: center;
    select {
      height: 32px;
      font-size: 13px;
      padding: 0 8px;
      border: 1px solid #d5d8de;
      border-radius: 4px;
      margin-right: 8px;
    }
    .input-search {
      input {
        height: 32px;
        font-size: 13px;
        padding: 0 10px;
      }
      button {
        height: 32px;
        font-size: 18px;
        line-height: 32px;
      }
    }
  }
  .link-btn {
    display: inline-block;
    font-size: 12px;
    width: 45px;
    padding: 3px 0;
    text-align: center;
    border-radius: 5px;
    text-decoration: none;
  }
  .ems-link {
    background-color: #d5d8de;
    border: 1px solid #d5d8de;
    &:hover {
      background-color: #b9bcc3;
      border: 1px solid #b9bcc3;
    }
  }
  .plant-link {
    background-color: var(--primary-500);
    border: 1px solid var(--primary-500);
    color: var(--grey-900);
    margin: 0 5px;
    &:hover {
      background-color: var(--primary-600);
      border: 1px solid var(--primary-600);
    }
  }
  .edit-link {
    background-color: var(--secondary-500);
    border: 1px solid var(--secondary-500);
    color: var(--white);
    &:hover {
      background-color: var(--secondary-600);
      border: 1px solid var(--secondary-600);
    }
  }
  .photo-btn {
    background-color: #4b8cf5;
    border: 1px solid #4b8cf5;
    color: #fff;
    margin-left: 5px;
    cursor: pointer;
    &:hover {
      background-color: #2d6ed4;
      border-color: #2d6ed4;
    }
  }
`;
const StatsSection = styled.div`
  display: flex;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid #e3e5e7;
  margin-bottom: 0;
`;

const StatCard = styled.button`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 12px 10px;
  border-radius: 8px;
  border: 2px solid ${({ active, color }) => active ? color : "#e3e5e7"};
  background-color: ${({ active, color }) => active ? `${color}12` : "#fff"};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ color }) => color};
    background-color: ${({ color }) => `${color}0d`};
  }

  .stat-count {
    font-size: 20px;
    font-weight: 700;
    color: ${({ active, color }) => active ? color : "#191919"};
    line-height: 1;
  }

  .stat-label {
    font-size: 12px;
    font-weight: 500;
    color: ${({ active, color }) => active ? color : "#888e98"};
  }
`;

const PhotoPopupOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const PhotoPopupBox = styled.div`
  background: #fff;
  border-radius: 10px;
  width: 900px;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
`;
const PhotoPopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e3e5e7;
  h3 { font-size: 16px; font-weight: 700; color: #191919; }
  button {
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #888;
    &:hover { color: #333; }
  }
`;
const PhotoPopupBody = styled.div`
  overflow-y: auto;
  padding: 20px 24px;
  flex: 1;
`;
const PhotoSection = styled.div`
  margin-bottom: 28px;
  &:last-child { margin-bottom: 0; }
`;
const PhotoSectionTitle = styled.h4`
  font-size: 14px;
  font-weight: 700;
  color: var(--grey-900);
  background-color: var(--primary-500);
  padding: 7px 14px;
  border-radius: 4px;
  margin-bottom: 14px;
`;
const PhotoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
`;
const PhotoCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  .cell-label {
    font-size: 12px;
    font-weight: 600;
    color: #4b515b;
    text-align: center;
  }
  .photo-placeholder {
    width: 100%;
    aspect-ratio: 4/3;
    background: #f5f6f8;
    border: 1px dashed #d5d8de;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #aaa;
    &.loading { color: #888; }
  }
  .photo-thumb {
    width: 100%;
    aspect-ratio: 4/3;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #e3e5e7;
    cursor: zoom-in;
    transition: opacity 0.15s;
    &:hover { opacity: 0.85; }
  }
  .photo-download-btn {
    width: 100%;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 0;
    border: 1px solid #d5d8de;
    border-radius: 4px;
    background: #fff;
    color: #4b515b;
    cursor: pointer;
    &:hover { background: #f5f6f8; }
    &:disabled { cursor: default; opacity: 0.6; }
  }
`;
const LightboxOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.88);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const LightboxImg = styled.img`
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
`;
const LightboxClose = styled.button`
  position: fixed;
  top: 20px;
  right: 24px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  font-size: 22px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover { background: rgba(255, 255, 255, 0.3); }
`;

const ChecklistSection = styled.div`
  padding: 20px 24px 8px;
  border-top: 1px solid #e3e5e7;
`;
const ChecklistList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;
const ChecklistRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f0f1f3;
  gap: 12px;
`;
const ChecklistQuestion = styled.div`
  font-size: 13px;
  color: #333;
  flex: 1;
  line-height: 1.4;
  .num {
    font-weight: 700;
    margin-right: 6px;
    color: var(--secondary-500);
  }
`;
const ChecklistOptions = styled.div`
  display: flex;
  gap: 6px;
  flex-shrink: 0;
`;
const ChecklistOption = styled.span`
  font-size: 12px;
  padding: 5px 10px;
  border-radius: 14px;
  border: 1px solid;
  font-weight: 600;
  cursor: default;
  background: ${({ active, value }) =>
    active
      ? value === "적합" ? "#1ab245"
      : value === "미흡" ? "#ff5353"
      : "#888e98"
      : "#fff"};
  color: ${({ active }) => active ? "#fff" : "#d5d8de"};
  border-color: ${({ active, value }) =>
    active
      ? value === "적합" ? "#1ab245"
      : value === "미흡" ? "#ff5353"
      : "#888e98"
      : "#e3e5e7"};
`;
const ChecklistFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 8px;
  button {
    padding: 10px 28px;
    background: var(--primary-500);
    color: var(--grey-900);
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    &:hover { background: var(--primary-600); }
  }
`;

const StatusBtn = styled.button`
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 12px;
  border: 1px solid ${({ color }) => color || "#888e98"};
  background: ${({ color }) => color ? `${color}18` : "#f5f6f8"};
  color: ${({ color }) => color || "#888e98"};
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    background: ${({ color }) => color || "#888e98"};
    color: #fff;
  }
`;

const LinkBadge = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: ${({ linked }) => (linked ? "#1ab245" : "#ff5353")};
`;

export default withTranslation()(withRouter(ProjectMain));
